export class GetBulkPaymentList {
  static readonly type = '[BulkPayment] GetBulkPaymentList';
  constructor(public page = 1, public limit = 5, public masterId = '', public searchValue = '') {}
}

export class ClearBulkPaymentList {
  static readonly type = '[BulkPayment] ClearBulkPaymentList';
}
